import axios from 'axios';
import i18next from 'i18next';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import socket from '../_helper/socketInstance';
import localforage from 'localforage';

const baseURL = process.env.REACT_APP_BASE_URL;

const axiosInstance = axios.create({
    baseURL,
});

const getClinic = () => {
    try {
        const raw = localStorage.getItem('currentHospitalAdmin');
        return raw ? JSON.parse(raw) : null;
    } catch {
        return null;
    }
};

const logoutUserOld = async () => {
    const admin = getClinic();
    const axiosAPI = axios.create({
        baseURL
    });
    try {
        const response = await axiosAPI.get(`clinic_admin/logout/${admin._id}`);
        if (response.data.status === "success") {
            logoutAndRedirectToLogin();
        }
    } catch (error) {
        console.error("Error fetching data:", error);
        logoutAndRedirectToLogin();
    } finally {
    }
};

const logoutAndRedirectToLogin = () => {
    const admin = getClinic();
    if (socket && socket.connected && admin) {
        socket.emit('userLogout', { userId: admin._id, userRole: admin.role }, () => {
            socket.disconnect();
        });
    }
    localStorage.removeItem("profileURL");
    localStorage.removeItem("hospitalAdminAuth");
    localStorage.removeItem("currentHospitalAdmin");
    localStorage.removeItem("auth0_hospital_admin_profile");
    localStorage.removeItem("Name");
    localStorage.setItem("authenticated", false);
    window.location.href = `${process.env.PUBLIC_URL}/login`;
};

const logoutUser = () => {
    localStorage.removeItem("profileURL");
    localStorage.removeItem("pharmacyPOSAuth");
    localStorage.removeItem("currentPharmacyPOS");
    localStorage.removeItem("auth0_hospital_admin_profile");
    localStorage.removeItem("Name");
    localStorage.setItem("authenticated", false);
    window.location.href = `${process.env.PUBLIC_URL}/login`;
}

// Utility function to display error messages
const displayError = (message, details = '') => {
    toast.warning(message);
    if (details) {
        console.error(details);
    }
};

// Utility function to display SweetAlert messages
const showAlert = (icon, title, text) => {
    return Swal.fire({
        icon,
        title,
        html: text,
    });
};

const showSessionExpiredAlert = () => {
    toast.success("Session expired. Please login again.", {
        toastId: "session-expired",
        autoClose: 2500,
    });
    logoutUser();
}

axiosInstance.interceptors.request.use(
    async (config) => {
        const lang = i18next.language;
        const token = localStorage.getItem('pharmacyPOSAuth');

        if (lang) {
            config.headers['Accept-Language'] = lang;
        }
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }

        // Skip license check for activation endpoint
        // if (!config.url.includes('/activate') && !config.url.includes('/login')) {
        //     try {
        //         await checkLicenseStatus();
        //     } catch (error) {
        //         // Trigger license check failure
        //         window.dispatchEvent(new CustomEvent('license-check-failed', { 
        //             detail: { reason: error.message }
        //         }));
                
        //         // Redirect to activation page
        //         window.location.href = `${process.env.PUBLIC_URL}/activate`;
                
        //         // Cancel the request
        //         return Promise.reject(new Error('License check failed'));
        //     }
        // }

        return config;
    },
    (error) => Promise.reject(error)
);

// // Add a response interceptor
axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response) {
            const { status, data } = error.response;
            const errorMessage = data.message || 'An error occurred';

            switch (status) {
                case 400:
                    displayError(errorMessage);
                    break;
                case 0:
                    showAlert('question', 'Connection Is Not Stable', `Please check your internet connection. It seems that it is not stable.<br>Detail: ${error.message}`);
                    break;
                case 401:
                    showSessionExpiredAlert();
                    break;
                case 422:
                    if (data.errors && data.errors.length > 0) {
                        data.errors.forEach(displayError);
                    } else {
                        displayError('Unprocessable Entity error occurred');
                    }
                    break;
                default:
                    displayError(errorMessage, data.errors || `Status code: ${status}`);
                    break;
            }
        } else if (error.request) {
            console.error('No response received:', error.request);
        } else {
            console.error('Request setup error:', error.message);
        }
        return Promise.reject(error);
    }
);


const checkLicenseStatus = async () => {
    try {
        const token = await localforage.getItem('license_token');
        if (!token) {
            throw new Error('No license token');
        }

        // You can also verify locally first
        const lastValidTime = await localforage.getItem('license_last_valid_time');
        const now = Date.now();

        if (lastValidTime && now < parseInt(lastValidTime) - 300000) {
            throw new Error('Time tampering detected');
        }

        return true;
    } catch (error) {
        throw error;
    }
};

export default axiosInstance;
